import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { guideSteps } from "@/mocks/home";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-section bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="使用指南"
            title="四步开始使用"
            subtitle="从选择入口到收藏追更，按下面的顺序走一遍，基本就能顺畅上手。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {guideSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 80}>
              <div className="relative h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
                <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-2xl">
                  <i className={step.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-900">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                <span className="absolute top-5 right-5 font-heading text-sm font-bold text-background-300">
                  0{index + 1}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}